import { convertDisplayTokenAmountToAtomic } from '../utils/tradeUnits';
import {
  applyFeeReduction,
  getFeeBasisPoints,
  integrateSellCurve,
  normalizeBigIntValue,
} from './curveMath';

export function getSellQuote({ globalConfig, currentGameState, tokenAmount }) {
  if (!globalConfig || !currentGameState) {
    throw new Error('Live game data is not ready.');
  }

  const tokenAmountInAtomic = convertDisplayTokenAmountToAtomic(
    tokenAmount,
    currentGameState.decimals ?? 6
  );
  const currentSupplyAtomic = normalizeBigIntValue(currentGameState.current_supply);
  const boostLamports = normalizeBigIntValue(currentGameState.boost);
  const grossLamportsOut = integrateSellCurve(currentSupplyAtomic, tokenAmountInAtomic, boostLamports);
  const feeBasisPoints = getFeeBasisPoints(globalConfig);
  const netLamportsOut = applyFeeReduction(grossLamportsOut, feeBasisPoints);

  return {
    feeBasisPoints: feeBasisPoints.toString(),
    grossLamportsOut: grossLamportsOut.toString(),
    netLamportsOut: netLamportsOut.toString(),
    tokenAmountInAtomic: tokenAmountInAtomic.toString(),
  };
}